/**
 * Dialog for filling template variables before sending a prompt message.
 * Renders a form with fields derived from parsed template variables,
 * validates input via Zod, and submits the filled values.
 */
import type { ReactNode } from 'react'

import { TemplateVariableForm } from '@/components/organisms/template-variable-form/template-variable-form.organism'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { ScrollArea } from '@/components/ui/scroll-area'

import type { TemplateFillDialogProps } from './template-fill-dialog.interface'

export const TemplateFillDialog: React.FC<TemplateFillDialogProps> = ({
  isOpen,
  onOpenChange,
  templateName,
  templateDescription,
  variableList,
  onSubmit,
  onCancel,
}): ReactNode => (
  <Dialog open={isOpen} onOpenChange={onOpenChange}>
    <DialogContent className="template-fill-dialog sm:max-w-lg">
      <DialogHeader>
        <DialogTitle>{templateName}</DialogTitle>
        <DialogDescription>{templateDescription}</DialogDescription>
      </DialogHeader>
      <ScrollArea className="template-fill-dialog-scroll max-h-[60vh]">
        <div className="template-fill-dialog-form pr-3">
          <TemplateVariableForm
            variableList={variableList}
            onSubmit={onSubmit}
            onCancel={onCancel}
            submitLabel="Send message"
            cancelLabel="Cancel"
          />
        </div>
      </ScrollArea>
    </DialogContent>
  </Dialog>
)

TemplateFillDialog.displayName = 'TemplateFillDialog'
